module.exports = __webpack_public_path__ + "img/googlemap.c6cc3b56.png";